module.exports = __webpack_public_path__ + "static/ro-trainings-1-2110ba2ddedcf859fe41d3dec715608e.jpg";